module.exports = __webpack_public_path__ + "static/media/logo.71c8cc11.png";